export default __webpack_public_path__ + "media/images/megamenu-img-01-270x370-eb2e30a5436e1bd468de4afef618c54d.jpg";